const createTypeOfResource = (resource) => {
  switch (resource) {
    case 'KeyUpdates':
    case 'Consultations':
    case 'Events':
    case 'PolicyAsks':
    case 'CommitteePublications':
      return resource.substring(0, resource.length - 1);
    case 'Tweets':
      return 'tweet';
    case 'Stakeholders':
      return 'stakeholder';
    case 'UpcomingEvents':
      return 'Event';
    case 'SocialMedia':
      return 'tweet';
    case 'LibraryMaterial':
    case 'LibraryArticles':
      return 'LibraryArticle';
    case 'Influence':
      return 'UserContent';
    case 'ParliamentLive':
      return 'RealtimeUtterance';
    case 'Regulations':
      return 'RegulationDocument';
    case 'RegulationDocuments':
      return 'RegulationDocument';
    case 'RegulationComments':
      return 'RegulationDocumentComment';
    default:
      return resource;
  }
};

const getRegulationSearchType = (singleSelectValues) => {
  const regulationsItemType = (singleSelectValues?.regulationItemType ?? 'Document').toLowerCase();
  if (regulationsItemType === 'comment') {
    return 'RegulationDocumentComment';
  }
  if (regulationsItemType === 'docket' || regulationsItemType === 'docket name') {
    return 'RegulationDocket';
  }
  return 'RegulationDocument';
};

const applyRegulationSearchRequestOverrides = (requestProperties, { singleSelectValues, regulationGroupByDocket }) => {
  const regulationsItemType = (singleSelectValues?.regulationItemType ?? 'Document').toLowerCase();
  if (regulationsItemType === 'comment') {
    return { ...requestProperties, type: 'RegulationDocumentComment' };
  }
  if (regulationsItemType === 'docket' || regulationsItemType === 'docket name') {
    return { ...requestProperties, type: 'RegulationDocket' };
  }
  if (regulationGroupByDocket) {
    return { ...requestProperties, collapseField: 'govDocketId' };
  }
  return requestProperties;
};

const changeTypeOfResource = (section) => {
  switch (section) {
    case 'PolicyAsks':
    case 'BriefingMaterial':
    case 'LobbyingMaterial':
    case 'Campaigns':
      return 'UserContent';
    case 'LibraryMaterial':
      return 'LibraryArticle';
    case 'ElectionKeyUpdates':
      return 'KeyUpdate';
    case 'ParliamentLive':
      return 'RealtimeUtterance';
    default:
      return createTypeOfResource(section);
  }
};

export { changeTypeOfResource, getRegulationSearchType, applyRegulationSearchRequestOverrides };
export default createTypeOfResource;
